function openBestsellers(evted, cityBestsellers) {
  var i, tabcontentbestsellers, tablinksbestsellers;
  tabcontentbestsellers = document.getElementsByClassName(
    "tabcontentbestsellers"
  );
  for (i = 0; i < tabcontentbestsellers.length; i++) {
    tabcontentbestsellers[i].style.display = "none";
  }
  tablinksbestsellers = document.getElementsByClassName("tablinksbestsellers");
  for (i = 0; i < tablinksbestsellers.length; i++) {
    tablinksbestsellers[i].className = tablinksbestsellers[i].className.replace(
      " active",
      ""
    );
  }
  document.getElementById(cityBestsellers).style.display = "block";
  evted.currentTarget.className += " active";
}

// Get the element with id="defaultOpen" and click on it
document.getElementById("defaultBestsellers").click();

var swiper = new Swiper(".swiperBestsellers", {
  slidesPerView: 1,
  spaceBetween: 10,
  slidesOffsetAfter: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2.2,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 5,
    },
    1024: {
      slidesPerView: 5.4,
      spaceBetween: 7,
    },
  },
});
